let handleInputChange = (event, This) => {

  let value = event.target.value,
      empresa = event.target.dataset.empresa,
      type = event.target.dataset.valueType

  This.props.dataEmpresas.empresas.filter( obj => {

    if((obj.id === JSON.parse(empresa).id) === true){

      //console.log(empresa)

      if(type === 'nombre_comercial'){

        //console.log(obj)

        obj.nombre_comercial = value

        This.props.dispatch({
          type:'CHANGE_DATA_EMPRESAS',
          payload: {
            dataEmpresa: obj
          }
        })

      }else if(type === 'nombre_fiscal'){

        //console.log(obj)

        obj.nombre_fiscal = value

        This.props.dispatch({
          type:'CHANGE_DATA_EMPRESAS',
          payload: {
            dataEmpresa: obj
          }
        })

      }else if(type === 'telefono'){

        //console.log(obj)

        obj.telefono = value

        This.props.dispatch({
          type:'CHANGE_DATA_EMPRESAS',
          payload: {
            dataEmpresa: obj
          }
        })

      }else if(type === 'correo'){

        //console.log(obj)

        obj.correo = value

        This.props.dispatch({
          type:'CHANGE_DATA_EMPRESAS',
          payload: {
            dataEmpresa: obj
          }
        })

      }else if(type === 'NIT'){

        //console.log(obj)

        obj.NIT = value

        This.props.dispatch({
          type:'CHANGE_DATA_EMPRESAS',
          payload: {
            dataEmpresa: obj
          }
        })

      }else if(type === 'direccion'){

        //console.log(obj)

        obj.direccion = value

        This.props.dispatch({
          type:'CHANGE_DATA_EMPRESAS',
          payload: {
            dataEmpresa: obj
          }
        })

      }else if(type === 'tipoEmpresa'){

        //console.log(obj)

        obj.tipo_empresa = value

        This.props.dispatch({
          type:'CHANGE_DATA_EMPRESAS',
          payload: {
            dataEmpresa: obj
          }
        })

      }else if(type === 'regimenFiscal'){

        //console.log(obj)

        obj.regimen_fiscal = value

        This.props.dispatch({
          type:'CHANGE_DATA_EMPRESAS',
          payload: {
            dataEmpresa: obj
          }
        })

      }else if(type === 'cuenta_banco'){

        //console.log(obj)

        obj.cuenta_banco = value

        This.props.dispatch({
          type:'CHANGE_DATA_EMPRESAS',
          payload: {
            dataEmpresa: obj
          }
        })

      }

    }

    return null

  })

}

export default handleInputChange;
